import React,{PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
export default class Brands extends Component{
    render(){
        return(
            <p className="sneaker-brands">
                {this.props.brands.reduce((accumulator,brand)=>`${accumulator} - ${brand}`)}
            </p>
        )
    }
}
Brands.propTypes={
    brands:propTypes.array
}
Brands.defaultProps={
    brands:[]
}

